import { SET_SA_DATA } from '../actions'
import dotProp from 'dot-prop-immutable';

const initialState = {
    tables: [],
}

export default (state, action) => {
    let state_ = state || initialState;
    switch (action.type) {
        case SET_SA_DATA:
            state_ = dotProp.set(state_, `tables`, action.data);
            return state_;
    }
    return state || initialState
}
